import { SVGProps, Ref, forwardRef } from 'react';

export const PlayCircleOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M8.571 7.194c.572-.463 1.376-.055 2.984.758l2.311 1.17C16.29 10.346 17.5 10.96 17.5 12s-1.211 1.652-3.634 2.878l-2.311 1.17c-1.608.813-2.412 1.22-2.984.758C8 16.343 8 15.284 8 13.169V10.83c0-2.115 0-3.173.571-3.636"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.383 1.004c7.7.162 10.443 5.243 10.61 10.48L23 12c0 5.5-2.75 11-11 11S1 17.5 1 12l.008-.516C1.177 6.162 4.008 1 12 1zM12 2.8c-3.692 0-5.894 1.21-7.21 2.79C3.423 7.228 2.8 9.517 2.8 12s.624 4.772 1.99 6.41C6.105 19.99 8.307 21.2 12 21.2s5.894-1.21 7.21-2.79c1.366-1.638 1.99-3.927 1.99-6.41s-.624-4.772-1.99-6.41C17.895 4.01 15.693 2.8 12 2.8"
            fill="currentColor"
        />
    </svg>
));
PlayCircleOutlinedSize24Glyph.displayName = 'PlayCircleOutlinedSize24Glyph';
